import React from 'react';
import JiraDescription from './jiradescription'; // Adjust the path based on your project structure
import {  FluxText } from '@meltwater/flux-web-components-react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Grid } from '@mui/material';
const JiraComments = ({ comments }) => {
  // console.log("JiraComments ", comments)

  const displaycomment = (comment) => {
    let retval;
    retval = (<Card >
      <CardContent>
        <div slot="header">
          <FluxText appearance="body-heavy" as="div" nowrap >
            {comment.updated} {comment.updateAuthor.displayName}
          </FluxText>
          <FluxText appearance="body2" as="div" nowrap >{comment.updateAuthor.timeZone}</FluxText>
        </div>

        <div slot="body">
          <JiraDescription data={comment.body} />
        </div>
      </CardContent>
    </Card >)


    return retval
  }

  return (
   
    <Grid container spacing={1} alignItems="stretch">
          
      {comments && comments.map((comment,index) => (
        <Grid key={index} item xs={12}  >
     
            {displaycomment(comment)}
 
        </Grid>
      ))}
      </Grid>
     

   
  );
};

export default JiraComments;
